import { Typography } from '@material-ui/core';
import Box from '@mui/material/Box';
import footerLogo from '../../../utils/assests/footer-logo.svg';
function FooterBar() {
  return (
    //   <Box>
    //   <p className='poweredby'>
    //     Powered by <img src={footerLogo} alt='' />
    //   </p>
    //   <p className='poweredText'>
    //     Partnered with LiquiLoans - RBI approved P2P <br /> NBFC. Investments are <br /> subject to risk. Risk of
    //     complete loss of principal <br /> exists.
    //   </p>
    // </Box>
    <Box>
      <p className='poweredby'>
        <span className='fw-600'>Powered by</span>{' '}
        <img src={footerLogo} alt='' />
      </p>
      <p className='poweredText'>
        Partnered with LiquiLoans - RBI approved P2P <br /> NBFC. Investments
        are subject to risk. Risk of
        <br /> complete loss of principal exists.
      </p>
    </Box>
  );
}
export default FooterBar;
